/**
 * Tasting Guides Products Bubbles Handler
 * Handles click interactions between product bubbles and product displays
 * Works with multiple sections on the same page
 */
class TastingGuidesBubbles {
  constructor(container) {
    this.container = container;
    this.bubbles = container.querySelectorAll('[data-product-bubble]');
    this.products = container.querySelectorAll('.tasting-guides-products__product');
    this.init();
  }

  init() {
    if (this.bubbles.length === 0 || this.products.length === 0) {
      return;
    }

    // Set initial state - show first product, hide others
    const firstBubble = this.bubbles[0];
    if (firstBubble) {
      const firstProductId = firstBubble.dataset.productId;
      // Ensure first bubble has active class
      firstBubble.classList.add('active');
      this.setActiveProduct(firstProductId);
    }

    // Add click listeners to bubbles
    this.bubbles.forEach((bubble) => {
      bubble.addEventListener('click', () => {
        const productId = bubble.dataset.productId;
        this.handleBubbleClick(productId, bubble);
      });
    });
  }

  handleBubbleClick(productId, clickedBubble) {
    // Remove active class from all bubbles
    this.bubbles.forEach(bubble => {
      bubble.classList.remove('active');
    });

    // Add active class to clicked bubble
    clickedBubble.classList.add('active');

    // Set the corresponding product as active
    this.setActiveProduct(productId);
  }

  setActiveProduct(productId) {
    // Hide all products
    this.products.forEach(product => {
      product.classList.remove('active');
      product.classList.add('hidden');
    });

    // Show the selected product by matching data-product-id
    const targetProduct = Array.from(this.products).find(
      product => product.dataset.productId === productId
    );

    if (targetProduct) {
      targetProduct.classList.remove('hidden');
      targetProduct.classList.add('active');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBubbles);
} else {
  initBubbles();
}

function initBubbles() {
  // Find all tasting guides products containers with bubbles style
  const containers = document.querySelectorAll('.tasting-guides-products__container');
  
  containers.forEach(container => {
    // Only initialize if this container has bubbles
    const bubblesContainer = container.querySelector('.tasting-guides-products__products-bubbles');
    if (bubblesContainer) {
      new TastingGuidesBubbles(container);
    }
  });
}

// Re-initialize on section load (for Shopify theme editor)
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  const container = section.querySelector('.tasting-guides-products__container');
  if (container) {
    const bubblesContainer = container.querySelector('.tasting-guides-products__products-bubbles');
    if (bubblesContainer) {
      new TastingGuidesBubbles(container);
    }
  }
});
